import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { AccountingCode, AccountingCodeList } from '../../../../../core/model';
import { PyStateUtils } from '../../../../../core/state';
import { AccountingCodesState, CartState, StateWithCart } from '../cart-state';
import { getCartState } from './feature.selector';

export const getAccountingCodesState: MemoizedSelector<StateWithCart, AccountingCodesState> = createSelector(
  getCartState,
  (state: CartState) => state && state.accountingCodes
);

export const getAccountingCodeModalOpen: MemoizedSelector<StateWithCart, boolean> = createSelector(
  getAccountingCodesState,
  (state) => state?.isModalOpen
);

export const getActiveAccountingCode: MemoizedSelector<StateWithCart, AccountingCode> = createSelector(
  getAccountingCodesState,
  (state) => state?.active
);

export const getAccountingCodeModalDismissed: MemoizedSelector<StateWithCart, boolean> = createSelector(
  getAccountingCodesState,
  (state) => state?.isModalDismissed
);

export const getAccountingCodeListLoaderState: MemoizedSelector<
  StateWithCart,
  StateUtils.LoaderState<AccountingCodeList>
> = createSelector(
  getAccountingCodesState,
  (state: AccountingCodesState) => state?.accountingCodeList || PyStateUtils.initialLoaderState
);

export const getAccountingCodeList: MemoizedSelector<StateWithCart, AccountingCodeList | undefined> = createSelector(
  getAccountingCodeListLoaderState,
  (state: StateUtils.LoaderState<AccountingCodeList>) => StateUtils.loaderValueSelector(state) || undefined
);

export const getAccountingCodeListLoading: MemoizedSelector<StateWithCart, boolean> = createSelector(
  getAccountingCodeListLoaderState,
  (state: StateUtils.LoaderState<AccountingCodeList>) => StateUtils.loaderLoadingSelector(state)
);
